import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    const columnTranslations = {
      columnAlert: formatMessage(messages.columnAlert),
      columnStatus: formatMessage(messages.columnStatus),
      columnPatient: formatMessage(messages.columnPatient),
      columnDateTime: formatMessage(messages.columnDateTime),
      columnLocation: formatMessage(messages.columnLocation),
      columnStudies: formatMessage(messages.columnStudies),

      tooltipStat: formatMessage(messages.tooltipStat),
      tooltipAdditionalViews: formatMessage(messages.tooltipAdditionalViews),
      tooltipHasPriority: formatMessage(messages.tooltipHasPriority),
      tooltipContactingPatientRequired: formatMessage(
        messages.tooltipContactingPatientRequired,
      ),
      tooltipHasPreviousAppointments: formatMessage(
        messages.tooltipHasPreviousAppointments,
      ),

      statusApproved: formatMessage(messages.statusApproved),
      statusRequiresReview: formatMessage(messages.statusRequiresReview),
      statusInReview: formatMessage(messages.statusInReview),

      btnView: formatMessage(messages.btnView),
      btnReview: formatMessage(messages.btnReview),
      btnEdit: formatMessage(messages.btnEdit),
    };

    return { columnTranslations };
  }, [formatMessage]);
  return translations;
};
export default useTranslations;
